
import XHeader from 'vux/src/components/x-header/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
export default {
data(){
return {
shopList:{},
goodsName:'',
sendMessage:''
}
},
components: {
XHeader,FormPreview,Divider
},
methods:{
getData(){

fetch('post',urlConfig.pointsMessageGet+this.id).then(response => {
this.shopList = response;
/*            this.sendMessage = response.sendMessage;
this.goodsName = response.goodsName;
this.shopList = [
{
label: '数量',
value:response.goodsNum
},
{
/!*     label: '内容',*!/
value:response.sendMessage

}
]*/
console.log(response,555,this.shopList)
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},
},
mounted() {
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.id = this.$route.query.id;
getken(this.getData)
}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/pointsMessage.vue